export const username = (customer) => {
  if (!customer.user) {
    return '';
  }

  if (!customer.user.username.includes('@')) {
    return 'Web user';
  }

  return customer.user.username;
};
